<template>
  <div class="width-100 min-height flex-column align-items-center justify-content-start" id="body-div">
    <div class="flex-column align-items-center justify-content-end width-100 bg-image" style="height: 11rem; padding: 0 5% 20px">
      <div class="width-100 flex-row align-items-center justify-content-spaceBetween" :style="{ height: bodyWidth * 0.9 * 0.15 + 'px' }">
        <van-image
          :src="user_info.shop_logo ? user_info.shop_logo : require('../../assets/image/shop/t.png')"
          width="15%"
          :height="bodyWidth * 0.9 * 0.15 + 'px'"
          fit="contain"
        />
        <div class="width-80 flex-column align-items-star justify-content-spaceBetween height-100">
          <div class="white fs-big">{{ user_info.name }}</div>
          <div class="flex-row align-items-center justify-content-spaceBetween width-100">
            <div style="border-radius: 5px; width: 11px; height: 13px" class="overflow-h">
              <van-image :src="require('../../assets/image/shop/place.png')" width="11px" height="13px" fit="fill" />
            </div>
            <div class="fs-mid-sml width-90" style="color: #c7dfff">{{ user_info.shop_address }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="width-100 flex-row align-items-center justify-content-center" style="height: 50px">
      <div class="grey-999 fs-mid-sml">当前登录的手机号：</div>
      <div class="fs-mid black">{{ user_info.phone }}</div>
    </div>
    <div
      style="border-top: 1px solid #eee; border-bottom: 1px solid #eee; height: 10rem"
      class="width-100 flex-row align-items-center justify-content-spaceBetween flex-wrap"
    >
      <div class="width-49 flex-column align-items-center justify-content-center height-100" @click="scanCode">
        <van-image :src="require('../../assets/image/shop/saoma.png')" width="3rem" height="3.45rem" fit="fill" />
        <div class="fs-mid black margin-ts">扫码核销</div>
      </div>
      <div class="height-100" style="width: 1px; background: #eee"></div>
      <div class="width-49 flex-column align-items-center justify-content-center height-100" @click="$router.push('/shop_list')">
        <van-image :src="require('../../assets/image/shop/list.png')" width="3rem" height="3.45rem" fit="fill" />
        <div class="fs-mid black margin-ts">核销记录</div>
      </div>
    </div>
    <div
      style="border-top: 1px solid #eee; border-bottom: 1px solid #eee; height: 10rem"
      class="width-100 flex-row align-items-center justify-content-spaceBetween flex-wrap"
    >
      <div class="width-49 flex-column align-items-center justify-content-center height-100" @click="$router.push('/shop_tj')">
        <van-image :src="require('../../assets/image/shop/hxjl.png')" width="3rem" height="3.45rem" fit="fill" />
        <div class="fs-mid black margin-ts">统计分析</div>
      </div>
      <div class="height-100" style="width: 1px; background: #eee"></div>
      <div class="width-49 flex-column align-items-center justify-content-center height-100" @click="$router.push('/shop_hx_list')">
        <van-image :src="require('../../assets/image/shop/hxlb.png')" width="4.2rem" height="3.45rem" fit="fill" />
        <div class="fs-mid black margin-ts">待核销列表</div>
      </div>
    </div>
    <van-overlay :show="show" class="flex-column align-items-center justify-content-center">
      <div class="width-80 br-mid overflow-h">
        <div :style="{ height: ((bodyWidth * 0.8) / 236) * 54 + 'px', width: '100%' }" class="bg-img"></div>
        <div class="width-100 flex-column align-items-center justify-content-center bg-white" style="padding: 20px 5%">
          <div class="width-100 textAlign-l fw-mid fs-mid-sml">您将核销的产品信息如下：</div>
          <van-image width="100%" height="8rem" class="margin-ts" :src="order_info.picture_url" fit="contain" />
          <div class="width-100 flex-row align-items-center justify-content-start margin-ts">
            <div class="fs-mid-sml grey-999 width-30">产品名称：</div>
            <div class="fs-mid-sml black">{{ order_info.name }}</div>
          </div>
          <div class="width-100 flex-row align-items-center justify-content-start margin-ts">
            <div class="fs-mid-sml grey-999 width-30">手机号：</div>
            <div class="fs-mid-sml black">{{ order_info.member_phone }}</div>
          </div>
          <div class="width-100 flex-row align-items-center justify-content-start margin-ts">
            <div class="fs-mid-sml grey-999 width-30">数量：</div>
            <div class="fs-mid-sml black">{{ order_info.num }}</div>
          </div>
          <van-image
            @click="write_goods"
            :src="require('../../assets/image/shop/button.png')"
            class="margin-t"
            width="70%"
            :height="(bodyWidth * 0.8 * 0.9 * 0.7 * 181) / 1026 + 'px'"
            fit="fill"
          />
        </div>
      </div>
      <van-icon name="close" class="margin-t" size="2rem" color="white" @click="show = false" />
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { get_clerk_data, get_write_goods_info, write_goods } from '@/api/shop';
export default {
  data() {
    return {
      user_info: {
        shop_logo: '',
        nickname: '',
        shop_address: '',
        phone: ''
      },
      bodyWidth: '',
      order_info: {
        name: '',
        num: 0,
        member_phone: '',
        picture_url: require('../../assets/image/home/computer.png')
      },
      show: false,
      order_no: 'YD1694169128621212230908'
    };
  },
  beforeMount() {
    const _this = this;
    get_clerk_data().then((res) => {
      console.log(res.data);
      if (res.code == 0) {
        this.user_info = res.data;
        if (this.$route.query.order_no) {
          get_write_goods_info({ order_no: this.$route.query.order_no }).then((re) => {
            if (re.code == 0) {
              let obj = re.data;
              obj.member_phone = '*******' + obj.member_phone;
              _this.order_info = obj;
              _this.show = true;
            } else {
              Toast(re.msg);
            }
          });
        }
      } else {
        Toast(res.msg);
        this.$router.replace({ path: '/login', query: { path: '/shop_home' } });
      }
    });
    this.$nextTick(() => {
      this.bodyWidth = document.getElementById('body-div').clientWidth;
    });
  },
  watch: {
    '$route.path': {
      deep: true,
      immediate: true,
      handler(val) {
        console.log(val, 'val');
      }
    }
  },
  methods: {
    // 扫描二维码
    scanCode() {
      let _this = this;
      // eslint-disable-next-line no-undef
      CP.showScanQr({
        completed: function (data) {
          let order_no = '';
          if (!data.data.includes('?')) {
            order_no = data.data;
            _this.order_no = data.data;
          } else {
            let l = data.data.split('?')[1].split('&');
            l.forEach((item) => {
              if (item.split('=')[0] == 'order_no') {
                order_no = item.split('=')[1];
                _this.order_no = item.split('=')[1];
              }
            });
          }
          // let data = 'YD1694169128621212230908';
          get_write_goods_info({ order_no: order_no }).then((res) => {
            if (res.code == 0) {
              let obj = res.data;
              obj.member_phone = '*******' + obj.member_phone;
              _this.order_info = obj;
              _this.show = true;
            } else {
              Toast(res.msg);
            }
          });
        },
        cpIncompatible: function () {
          Toast('', '此环境不支持此方法');
        },
        scanType: ['qrCode', 'barCode'],
        needResult: 1
      });
    },
    write_goods() {
      write_goods({ order_no: this.order_no }).then((res) => {
        if (res.code == 0) {
          this.show = false;
          Toast('核销成功！');
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>

<style scoped>
.bg-image {
  background-image: url('../../assets/image/shop/bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.bg-img {
  background-image: url('../../assets/image/shop/top.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
</style>